export default __webpack_public_path__ + "static/media/hht2_direction_quiztime_01.f40218d2.png";